export enum ReportType {
  Billing = 'billing',
  CustomerOverview = 'customer-overview',
  CustomerPoints = 'customer-points',
  TierProgress = 'tier-progress',
  TransactionPointsHistory = 'transaction-points-history',
}

export const BillingReportDefaultStartDate = '2024-09-01';

export enum ReportStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}
